window.$ = window.jQuery = require('jquery')

$(function () {

    $('.rd-goto-url').on('click', function () {
        window.location.href = $(this).data('url')
    })
})
